import React from 'react';
import { Typography } from '@material-ui/core';

const WidgetTitle = props => (
	<Typography component="h2" variant="h5" {...props} />
);

export default WidgetTitle;
